module.exports = __webpack_public_path__ + "static/media/ope_maria_856x1284.937975f8.jpg";